'use client';

import { c as _c } from "react/compiler-runtime";
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { aspCond } from '@module/helpers/conditions/condition';
import { DropdownMenuItem } from '@pc/components/ui/dropdown-menu';
import { useRouter } from 'next/navigation';
export default function UserInfo() {
  const $ = _c(17);
  const router = useRouter();
  const {
    userInfo
  } = useGetLoginInfoQuery();
  if (!userInfo) {
    return null;
  }
  let t0;
  if ($[0] !== router) {
    t0 = () => {
      if (aspCond.if("iframe-asp")) {
        return;
      }
      router.push("/my/modify");
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== userInfo.imgProfile) {
    t1 = <img src={userInfo.imgProfile} alt={"\uD504\uB85C\uD544"} width={44} height={44} className="aspect-square cursor-pointer rounded-[50px] object-cover" />;
    $[2] = userInfo.imgProfile;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = userInfo?.nick;
  let t3;
  if ($[4] !== t2) {
    t3 = <span className="block w-[200px] cursor-pointer truncate font-medium text-[15px] text-baseFg">{t2}</span>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = userInfo?.id;
  let t5;
  if ($[6] !== t4) {
    t5 = <span className="block cursor-pointer truncate font-normal text-[13px] text-colorFg09">{t4}</span>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <div className="min-w-0 flex-1">{t3}{t5}</div>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t1 || $[12] !== t6) {
    t7 = <div className="flex w-full items-center gap-4 px-4 pt-4 pb-3">{t1}{t6}</div>;
    $[11] = t1;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t0 || $[15] !== t7) {
    t8 = <DropdownMenuItem className="cursor-pointer px-0 pt-9 pb-6 data-[highlighted]:bg-transparent" onClick={t0}>{t7}</DropdownMenuItem>;
    $[14] = t0;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}